// plugins/vehicles.ts (SSR Initialization Only)
import { defineNuxtPlugin } from '#imports'
import { useVehiclesStore } from '~/stores/vehicles'
import type { NuxtApp } from '#imports'

export default defineNuxtPlugin(async (nuxtApp) => {
  // Use type assertion for hooks property if NuxtApp type is incomplete
  (nuxtApp as any).hooks.hook('app:created', async () => {
    // For server-side, ensure the vehicles data is loaded
    if (process.server) {
      // console.log('[vehicles plugin] Restored: Server-side initialization') // Keep console logs commented for cleaner output unless debugging
      const vehiclesStore = useVehiclesStore()
      try {
        // Use fetchVehicles instead of ensureInitialized
        await vehiclesStore.fetchVehicles()
        // console.log('[vehicles plugin] vehiclesStore initialized on server via fetchVehicles.')
      } catch (error) {
        console.error('[vehicles plugin] Error during server-side fetchVehicles:', error) // Log errors if they occur
      }
    }
  })

  // --- Client-Side Check (Optional) ---
  // You might not need client-side initialization here if 
  // components handle their own data needs or if another client plugin does it.
  /* 
  else { 
    // console.log('[vehicles plugin] Running on client.')
    // const vehiclesStore = useVehiclesStore()
    // if (!vehiclesStore.isDataLoaded) {
    //   console.log('[vehicles plugin] Data not loaded on client, triggering fetchVehicles...')
    //   // Don't await here to avoid blocking app hydration
    //   vehiclesStore.fetchVehicles().catch(error => {
    //      console.error('[vehicles plugin] Error during client-side fetchVehicles:', error)
    //   })
    // }
  }
  */

  // console.log('[vehicles plugin] Finished.')
})
